import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GuestRegisterGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const otpValidated = sessionStorage.getItem('otpValidated') === 'true';
    if (!otpValidated) {
      this.router.navigate(['/guest']);
      return false;
    }
    return true;
  }
} 